/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type prospects_UpsertProspectEmailTemplateRequest = {
    body_text: string;
    language: prospects_UpsertProspectEmailTemplateRequest.language;
    subject: string;
};
export namespace prospects_UpsertProspectEmailTemplateRequest {
    export enum language {
        DE = 'de',
        EN = 'en',
        ES = 'es',
        FR = 'fr',
        IT = 'it',
        PT = 'pt',
    }
}

